import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { PropsWithChildren } from 'react';

import WhatIsCountdownPopover from '@/components/WhatIsCountdownPopover/WhatIsCountdownPopover';
import { useBidCountdown } from '@/hooks/useBidCountdown';

type Props = PropsWithChildren<{
    timeStamp: number;
}>;

/**
 * Shows a countdown starting at 21 seconds for the current item
 */
const BidCountDownComponent = ({ children, timeStamp }: Props) => {
    const { count, isLastFiveSeconds } = useBidCountdown(timeStamp);

    return (
        <div className="w-full">
            {isLastFiveSeconds ? (
                <>
                    <div className="relative mb-xs h-[10px] bg-[#e3e3e3]">
                        <div
                            className="absolute right-0 h-[10px] bg-[#cc2f28] transition-all duration-200 ease-in"
                            style={{ width: `${(count / 5) * 100}%` }}
                        />
                    </div>
                    <div className="flex flex-row items-center justify-between">
                        <span
                            aria-label="time left to bid"
                            className="inline-block min-w-[200px]"
                        >
                            <FormattedMessage
                                id="itemBidding.leftToBid"
                                values={{
                                    count: (
                                        <span
                                            className="font-semibold text-[#cc2f28]"
                                            key="bid-count-down-count"
                                        >
                                            {count}
                                        </span>
                                    ),
                                }}
                            />
                        </span>
                        <WhatIsCountdownPopover />
                    </div>
                </>
            ) : (
                children && <div className="mt-[20px]">{children}</div>
            )}
        </div>
    );
};

export const BidCountDown = BidCountDownComponent;
